var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',[_c('v-data-table',{attrs:{"items":_vm.clientManifest,"headers":_vm.headers},scopedSlots:_vm._u([{key:"item",fn:function(props){return [_c('tr',_vm._l((_vm.headers),function(header,index){return _c('td',{key:index,staticStyle:{"text-align":"center"}},[_vm._v(_vm._s(props.item[header.value]))])}),0)]}}])})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a5042e04","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/util/CreateClient/CsvPreview.vue
// module id = null
// module chunks = 